export function sendTo(href: string) {
  window.location.href = href;
}

export function redirectToSignIn(additionalQueryParam = "") {
  window.location.href = "/auth?redirect_to=" + window.location.href + (additionalQueryParam.length ? `?${additionalQueryParam}` : "");
}
